import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  ShowThisField,
  LabelInput,
  LabelTextArea,
  PageBreakAfterToggle,
} from './shared'
import { Input } from 'components/Input/Input'
import { FancyToggle } from 'apps/builder/components/settings/modal'
import { validateWholeInteger } from 'apps/builder/lib/input-validation'

export const GPSMoreSettings = entry => {
  const entryPDF = {
    showThisFieldType: 'pdf',
    ...entry,
  }

  const entryWeb = {
    showThisFieldType: 'web',
    ...entry,
  }

  const entryExport = {
    labelType: 'export',
    ...entry,
  }

  const entryReceipt = {
    labelType: 'receipt',
    ...entry,
  }

  return (
    <>
      <div className="settings--row">
        <div className="checkbox-labels-wrapper">
          <Accuracy {...entry} />
          <Timeout {...entry} />
        </div>
        <div className="show-this-field-wrapper">
          <ForceAccuracy {...entry} />
        </div>
      </div>
      <div className="settings--row">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Visibility</label>
          <ShowThisField {...entryPDF} />
          <ShowThisField {...entryWeb} />
        </div>
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <PageBreakAfterToggle {...entry} />
          </div>
        </div>
      </div>
      <label className="settings--label">Labels</label>
      <div className="checkbox-labels-wrapper">
        <LabelInput {...entryExport} />
        <LabelInput {...entryReceipt} />
      </div>
      <LabelTextArea {...entry} />
    </>
  )
}

const Accuracy = ({ guid, gps_accuracy }) => {
  const dispatch = useDispatch()
  const updateAccuracy = value => {
    dispatch(
      updateEntry({
        guid,
        gps_accuracy: value,
      })
    )
  }
  const [valid, validate] = useState(true)
  const validateValue = value => {
    const validation = validateWholeInteger(value)
    validation ? validate(true) : validate(false)
    return validation
  }
  const change = input => {
    const isValid = validateValue(input)
    isValid ? updateAccuracy(input) : ''
  }
  const inputProps = {
    value: gps_accuracy,
    placeholder: ' ',
    id: `${guid}-accuracy-m`,
    update: change,
    label: `Accuracy(m)`,
    additionalClass: 'settings--inputs',
    maxLength: 7,
    error: !valid,
    errorText: 'Entered value is not a valid number',
  }

  return (
    <div className="checkbox-label">
      <Input {...inputProps} />
    </div>
  )
}

const Timeout = ({ guid, gps_timeout }) => {
  const dispatch = useDispatch()
  const updateTimeout = value => {
    dispatch(
      updateEntry({
        guid,
        gps_timeout: value,
      })
    )
  }
  const [valid, validate] = useState(true)
  const validateValue = value => {
    const validation = validateWholeInteger(value)
    validation ? validate(true) : validate(false)
    return validation
  }
  const change = input => {
    const isValid = validateValue(input)
    isValid ? updateTimeout(input) : ''
  }
  const inputProps = {
    value: gps_timeout,
    placeholder: ' ',
    id: `${guid}-accuracy-m`,
    update: change,
    label: `Timeout(ms)`,
    additionalClass: 'settings--inputs',
    maxLength: 9,
    error: !valid,
    errorText: 'Entered value is not a valid number',
  }

  return (
    <div className="checkbox-label">
      <Input {...inputProps} />
    </div>
  )
}

const ForceAccuracy = ({ guid, gps_accuracy_required }) => {
  const dispatch = useDispatch()
  return (
    <div className="toggles-group">
      <div className="toggle-wrapper">
        <FancyToggle
          label="Force Accuracy"
          id={guid}
          active={gps_accuracy_required}
          inlineBorderTooltipStyle={true}
          onChange={checked => {
            dispatch(
              updateEntry({
                guid,
                gps_accuracy_required: checked,
              })
            )
          }}
          className={'photo-more-settings'}
          tooltip={`If the mobile app doesn't get the accurate location before timing out, no location will be captured.`}
          tooltipDirection="bottom"
        />
      </div>
    </div>
  )
}
